import { Component } from "@angular/core";
import {
    NavController,
    AlertController,
    ToastController,
    MenuController
} from "ionic-angular";
import { HomePage } from "../home/home";
import { APIServiceProvider } from "./../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";
import { UserService } from "../../services/user.service";
import { FirebaseService } from "../../services/firebase.service";
import { Platform } from "ionic-angular";

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';  

@Component({
    selector: "page-login",
    templateUrl: "login.html"
})
export class LoginPage {
    loginData: any = {
        email: "",
        password: "",
        from: "fa"
    };
    public firebaseProvider: any;

    public disableLogin = false;
    public isMobile: any = false;

    constructor(
        public nav: NavController,
        public helperService: HelperServiceProvider,
        public apiService: APIServiceProvider,
        public forgotCtrl: AlertController,
        public menu: MenuController,
        public toastCtrl: ToastController,
        private userService: UserService,
        public platform: Platform,
        private firebase: FirebaseService
    ) {
        this.menu.swipeEnable(false);
    }

    ionViewDidLoad() {
        if (this.platform.is("cordova")) {
            this.isMobile = true;
        }
    }

    // login and go to home page
    login() {
        this.helperService.showLoader("Authenticating..");
        this.disableLogin = true;
        this.apiService.login("signin", this.loginData).subscribe(
            response => {
                localStorage.setItem(
                    "user-id",
                    response["data"]["user"]["user_id"]
                );
                localStorage.setItem(
                    "user_depo_id",
                    response["data"]["user"]["user_depo_id"]
                );
                localStorage.setItem(
                    "user_depo_name",
                    response["data"]["user"]["user_depo_name"]
                );
                localStorage.setItem(
                    "user-name",
                    response["data"]["user"]["user_name"]
                );

                localStorage.setItem("gp_token", response["data"]["token"]);

                localStorage.setItem(
                    "manager_user_id",
                    response["data"]["user"]["user_id"]
                );
                this.notifyUser(response["data"]["user"]);
                this.helperService.dismissLoader();
                this.nav.setRoot(HomePage);
            },
            error => {
                this.disableLogin = false;
                this.helperService.dismissLoader();

                var message = error["error"]["msg"];

                if (typeof message === "undefined") {
                    this.helperService.presentToast(
                        "Internet/Network Error! Please check your internet connection"
                    );
                    return;
                }

                for (var i = 0; i <= 5; i++) {
                    message = message.replace("<br>", " ");
                }

                this.helperService.presentToast(message);
            }
        );
    }

    forgotPass() {
        let forgot = this.forgotCtrl.create({
            title: "Forgot Password?",
            message: "Enter you email address to send a reset link password.",
            inputs: [
                {
                    name: "email",
                    placeholder: "Email",
                    type: "email"
                }
            ],
            buttons: [
                {
                    text: "Cancel",
                    handler: data => {
                        console.log("Cancel clicked");
                    }
                },
                {
                    text: "Send",
                    handler: data => {
                        console.log("Send clicked");
                        let toast = this.toastCtrl.create({
                            message: "Email was sended successfully",
                            duration: 3000,
                            position: "top",
                            cssClass: "dark-trans",
                            closeButtonText: "OK",
                            showCloseButton: true
                        });
                        toast.present();
                    }
                }
            ]
        });
        forgot.present();
    }

    firebaseLogin() {
        let self = this;

        localStorage.setItem("firebase-login", "true");
        this.disableLogin = true;

        firebase
            .auth()
            .signInWithPopup(this.firebase.firebaseProvider)
            .then(function(result) {
                self.processFirebseSignin(result, self);
            });
    }

    processFirebseSignin(result, self) {
        localStorage.setItem(
            "gp_img",
            result["additionalUserInfo"]["profile"]["picture"]
        );

        if (result["user"] && result.credential) {
            const postParams = {
                token: result["credential"]["idToken"],
                from: "fa"
            };
            self.helperService.showLoader("Authenticating..");
            self.apiService
                .post("validate-firebase-auth", postParams)
                .subscribe(
                    response => {
                        localStorage.setItem("firebase-login", "false");
                        localStorage.setItem(
                            "user-id",
                            response["data"]["user"]["user_id"]
                        );
                        localStorage.setItem(
                            "user_depo_id",
                            response["data"]["user"]["user_depo_id"]
                        );
                        localStorage.setItem(
                            "user_depo_name",
                            response["data"]["user"]["user_depo_name"]
                        );
                        localStorage.setItem(
                            "user-name",
                            response["data"]["user"]["user_name"]
                        );
                        localStorage.setItem(
                            "gp_token",
                            response["data"]["token"]
                        );
                        self.notifyUser(response["data"]["user"]);
                        self.helperService.dismissLoader();
                        localStorage.removeItem("firebase-login");

                        localStorage.setItem(
                            "manager_user_id",
                            response["data"]["user"]["user_id"]
                        );

                        self.nav.setRoot(HomePage);
                    },
                    error => {
                        self.disableLogin = false;
                        self.helperService.dismissLoader();
                        var message = error["error"]["msg"];
                        for (var i = 0; i <= 5; i++) {
                            message = message.replace("<br>", " ");
                        }
                        self.helperService.presentToast(message);
                    }
                );
        }
    }

    notifyUser(payload) {
        const user = {
            "user-id": payload["user_id"],
            "user-name": payload["user_name"]
        };
        this.userService.userStatusChanged.emit(user);
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts